/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ClmtoInfo {

    /**
     * 支払契約番号
     */
    payCtrNo?: string;
    /**
     * まとめ請求区分コード
     */
    mtmclmDivcd?: string;
    /**
     * まとめ請求区分コード名称
     */
    mtmclmDivAname?: string;
    /**
     * 請求先名漢字
     */
    clmtoMeiKanji?: string;
    /**
     * 請求先名カナ
     */
    clmtoMeiKana?: string;
    /**
     * お客さま番号
     */
    visitornumber?: string;
}

